import { useEffect, useState } from 'react'
import {
  Box,
  Divider,
  MenuItem,
  Select,
  Typography,
  FormControlLabel,
  Grid,
  Checkbox,
} from '@material-ui/core'
import { Formik, Form, ErrorMessage } from 'formik'
import axios from 'axios'
import * as Yup from 'yup'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import _ from 'lodash'
import GreenTick from '../../svgs/greentick'
import RedCross from '../../svgs/redcross'
import { InputAdornment } from '@material-ui/core'
import { Input, InputLabel, FormControl } from '@material-ui/core'
import SectionHeader from '../SectionHeader'
import UploadFile from '../UploadFile'
import FilledButton from '../FilledButton'
import history from '../../routes/history'
import urlStrings from '../../utils/urlStrings'
import { applicationService } from '../../Services/ApplicationService'
import {
  INPROGRESS,
  SUCCESS,
  ERROR,
  DISPATCH_TIMINGS_VALUES,
  $perKW,
  UNDERLYING_PROGRAM_VALUES,
  get24HrsFormatValue,
  get12HrsFormatValue,
} from './constants'
import TextError from '../../Formik/TextError'
import { getSessionToken } from '../../utils/helper'
import { useStyles } from './styles'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}
const SiteForm = (props) => {
  const { site, setLoading } = props
  const classes = useStyles()
  const [openBodySnackBar, setOpenBodySnackBar] = useState(false)
  const [state, setState] = useState(INPROGRESS)
  const [error, setError] = useState(null)
  const handleBodySnackBarClose = () => {
    setOpenBodySnackBar(false)
  }
  const initialValues = {
    name: site ? site.name : '',
    address: site ? site.address : '',
    phone_number: site ? site.phone_number : '',
    site_id: site ? site.site_id : '',
    dispatch_capacity: site ? site.dispatch_capacity : '',
    dispatch_timings: site
      ? `${get12HrsFormatValue(
        site.dispatch_starttime,
      )} PM To ${get12HrsFormatValue(site.dispatch_endtime)} PM`
      : '',
    program: site ? site.program : '',
    rate: site ? site.rate : '',
    electric_account_number: site ? site.electric_account_number : '',
    electric_meter_number: site ? site.electric_meter_number : '',
    amendment_form: site ? site?.amendment_form_presigned_url : '',
    agreement_form: site ? site?.agreement_form_presigned_url : '',
    tandc_form: site ? site?.tandc_form_presigned_url : '',
    approval_form: site ? site?.approval_form_presigned_url : '',
    accept: false,
  }
  const validationSchema = Yup.object({
    name: Yup.string()
      .required('*required')
      .min(2, 'Minimum 2 chars')
      .max(80, 'Maximum 80 chars'),
    address: Yup.string()
      .min(2, 'Minimum 2 chars')
      .max(80, 'Maximum 80 chars')
      .required('*required'),
    phone_number: Yup.string()
      .required('*required')
      .matches(/^[0-9 ]+$/, '*only numbers allowed')
      .min(10, 'Must be equal to 10 digits')
      .max(10, 'Must be equal to 10 digits'),
    site_id: Yup.string()
      .required('*required')
      .min(2, 'Minimum 2 chars')
      .max(9, 'Maximum 9 chars')
      .matches(/^[0-9 ]+$/, '*only numbers allowed'),
    dispatch_capacity: Yup.number().test(
      'dispatchCapacityCheck',
      'Must be less than or equal to 15.36, Greater than 0 and rounded to 2 decimal digits',
      (number) => {
        return number > 0 &&
          number <= 15.36 &&
          Number.isInteger(Math.round(number * 100))
          ? true
          : false
      },
    ),
    dispatch_timings: Yup.string().required('*required'),
    program: Yup.string().required('*required'),
    rate: Yup.string().required('*required'),
    electric_account_number: Yup.string()
      .required('*required')
      .matches(/^[0-9 ]+$/, '*only numbers allowed')
      .min(6, 'Must be greater than equal to 6 digits')
      .max(12, 'Must be less than equal to 12 digits'),
    electric_meter_number: Yup.string()
      .required('*required')
      .matches(/^([A-Za-z0-9]+)$/, '*only alphanumeric allowed')
      .min(12, 'Must be 12 digits')
      .max(12, 'Must be 12 digits'),
    amendment_form: Yup.string(),
    agreement_form: Yup.string(),
    tandc_form: Yup.string().required('*required'),
    approval_form: Yup.string().required('*required'),
  })
  const reactOnSubmit = (formik) => {
    const values = formik.values

    if (site) updateApplicationForm(values, formik, site)
    else submitApplicationForm(values, formik)
  }
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Heco-Authorization': getSessionToken(),
    },
  }

  const updateApplicationForm = (values, formik, site) => {
    var data = new FormData()
    var payload = {}
    if (values.name !== site.name) payload.name = values.name
    if (values.address !== site.address) payload.address = values.address
    if (values.phone_number !== site.phone_number)
      payload.phone_number = values.phone_number
    if (values.site_id !== site.site_id) payload.site_id = values.site_id
    if (values.dispatch_capacity !== site.dispatch_capacity)
      payload.dispatch_capacity = values.dispatch_capacity
    if (values.dispatch_timings?.split(' ')[0] !== site.dispatch_starttime)
      payload.dispatch_starttime = get24HrsFormatValue(
        values.dispatch_timings?.split(' ')[0],
      )
    if (values.dispatch_timings?.split(' ')[3] !== site.dispatch_endtime)
      payload.dispatch_endtime = get24HrsFormatValue(
        values.dispatch_timings?.split(' ')[3],
      )
    if (values.program !== site.program) payload.program = values.program
    if (values.rate !== site.rate) payload.rate = values.rate
    if (values.electric_account_number !== site.electric_account_number)
      payload.electric_account_number = values.electric_account_number
    if (values.electric_meter_number !== site.electric_meter_number)
      payload.electric_meter_number = values.electric_meter_number
    var json = JSON.stringify(payload)
    var blob = new Blob([json], {
      type: 'application/json',
    })
    data.append('form', blob)
    if (values.amendment_form !== site.amendment_form_presigned_url)
      data.append('amendment_form', values.amendment_form)
    else {
      blob = new Blob([], {
        type: 'multipart/form-data',
      })
      data.append('amendment_form', blob)
    }
    if (values.agreement_form !== site.agreement_form_presigned_url)
      data.append('agreement_form', values.agreement_form)
    else {
      blob = new Blob([], {
        type: 'multipart/form-data',
      })
      data.append('agreement_form', blob)
    }
    if (values.tandc_form !== site.tandc_form_presigned_url)
      data.append('tandc_form', values.tandc_form)
    else {
      blob = new Blob([], {
        type: 'multipart/form-data',
      })
      data.append('tandc_form', blob)
    }

    if (values.approval_form !== site.approval_form_presigned_url)
      data.append('approval_form', values.approval_form)
    else {
      blob = new Blob([], {
        type: 'multipart/form-data',
      })
      data.append('approval_form', blob)
    }
    setLoading(true)
    console.log('payload', payload)
    console.log('data', data)
    applicationService.updateApplicationBySiteId(site?.site_id, data, config)
      .then((success) => {
        setLoading(false)
        setState(SUCCESS)
        setOpenBodySnackBar(true)
        formik.resetForm()
        history.push('/installer')
      })
      .catch((error) => {
        setLoading(false)
        setState(ERROR)
        setError(error?.data?.error?.displayMessage)
        setOpenBodySnackBar(true)
      })
  }

  const submitApplicationForm = (values, formik) => {
    var data = new FormData()
    const payload = {
      name: values.name,
      address: values.address,
      phone_number: values.phone_number,
      site_id: values.site_id,
      dispatch_capacity: values.dispatch_capacity,
      dispatch_starttime: get24HrsFormatValue(
        values.dispatch_timings.split(' ')[0],
      ),
      dispatch_endtime: get24HrsFormatValue(
        values.dispatch_timings.split(' ')[3],
      ),
      program: values.program,
      rate: values.rate,
      electric_account_number: values.electric_account_number,
      electric_meter_number: values.electric_meter_number,
    }
    var json = JSON.stringify(payload)
    var blob = new Blob([json], {
      type: 'application/json',
    })
    data.append('amendment_form', values.amendment_form)
    data.append('form', blob)
    data.append('agreement_form', values.agreement_form)
    data.append('tandc_form', values.tandc_form)
    data.append('approval_form', values.approval_form)
    setLoading(true)
    const url = urlStrings.getApiUrl('application/submit')
    applicationService.createApplicationBySiteId(data, config)
      .then((success) => {
        setLoading(false)
        setState(SUCCESS)
        setOpenBodySnackBar(true)
        formik.resetForm()
        history.push('/installer')
      })
      .catch((error) => {
        setLoading(false)
        setState(ERROR)
        setError(error?.data?.error?.displayMessage)
        setOpenBodySnackBar(true)
        if (String(error).search(401) !== -1) history.push('/')
      })
  }
  return (
    <>
      {' '}
      {openBodySnackBar ? (
        state === SUCCESS ? (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openBodySnackBar}
            onClose={handleBodySnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleBodySnackBarClose} severity="success">
              Site Application submitted successfully!
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openBodySnackBar}
            onClose={handleBodySnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleBodySnackBarClose} severity="error">
              {error ? error : `Site Application submission unsuccessful!`}
            </Alert>
          </Snackbar>
        )
      ) : null}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={reactOnSubmit}
      >
        {(formik) => (
          <Form className={classes.layout}>
            <Box className={classes.siteform}>
              <div className={classes.layoutsitedata}>
                <SectionHeader text="Enter the following details ( All fields mandatory )"></SectionHeader>
                <Box className={classes.formfieldslayoutsitedata}>
                  <Box className={classes.formfieldssitedata}>
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        {' '}
                        <InputLabel
                          id="name"
                          htmlFor="name"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          Name of Customer
                        </InputLabel>
                        <Input
                          labelid="name"
                          id="name"
                          name="name"
                          classes={{ root: classes.rootsitedata }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.name ? (
                                formik.errors.name ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      AlphaNumeric and Special Characters
                                      Allowed, Min 2 and Max 80 chars
                                    </Typography>
                                    <RedCross></RedCross>
                                  </Box>
                                ) : (
                                  <GreenTick></GreenTick>
                                )
                              ) : null}
                            </InputAdornment>
                          }
                          onChange={(event) => {
                            formik.setFieldValue('name', event.target.value)
                          }}
                          value={formik.values.name}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              ? e.target.value.slice(0, 80)
                              : e.target.value
                          }}
                        ></Input>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        {' '}
                        <InputLabel
                          id="address"
                          htmlFor="address"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          Address
                        </InputLabel>
                        <Input
                          labelid="address"
                          id="address"
                          name="address"
                          classes={{ root: classes.rootsitedata }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.address ? (
                                formik.errors.address ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      AlphaNumeric and Special Characters
                                      Allowed, Min 2 and Max 80 chars
                                    </Typography>
                                    <RedCross></RedCross>
                                  </Box>
                                ) : (
                                  <GreenTick></GreenTick>
                                )
                              ) : null}
                            </InputAdornment>
                          }
                          onChange={(event) => {
                            formik.setFieldValue(
                              'address',
                              event.target.value,
                            )
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              ? e.target.value.slice(0, 80)
                              : e.target.value
                          }}
                          value={formik.values.address}
                        ></Input>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        {' '}
                        <InputLabel
                          id="phone_number"
                          htmlFor="phone_number"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          Phone Number
                        </InputLabel>
                        <Input
                          labelid="phone_number"
                          id="phone_number"
                          name="phone_number"
                          classes={{ root: classes.rootsitedata }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.phone_number ? (
                                formik.errors.phone_number ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      {`Numeric characters allowed, 10 digits only`}
                                    </Typography>
                                    <RedCross></RedCross>
                                  </Box>
                                ) : (
                                  <GreenTick></GreenTick>
                                )
                              ) : null}
                            </InputAdornment>
                          }
                          onChange={(event) => {
                            formik.setFieldValue(
                              'phone_number',
                              event.target.value,
                            )
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              ? e.target.value.slice(0, 10)
                              : e.target.value
                          }}
                          value={formik.values.phone_number}
                        ></Input>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        {' '}
                        <InputLabel
                          id="site_id"
                          htmlFor="site_id"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          Enphase Site ID
                          <ErrorMessage
                            name="site_id"
                            component={TextError}
                          ></ErrorMessage>
                        </InputLabel>
                        <Input
                          labelid="site_id"
                          id="site_id"
                          name="site_id"
                          classes={{ root: classes.rootsitedata }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.site_id ? (
                                formik.errors.site_id ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      Numeric characters allowed, Min 2 and
                                      Max 9 digits
                                    </Typography>
                                    <RedCross></RedCross>
                                  </Box>
                                ) : (
                                  <GreenTick></GreenTick>
                                )
                              ) : null}
                            </InputAdornment>
                          }
                          onChange={(event) => {
                            formik.setFieldValue(
                              'site_id',
                              event.target.value,
                            )
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              ? e.target.value.slice(0, 9)
                              : e.target.value
                          }}
                          value={formik.values.site_id}
                        ></Input>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        {' '}
                        <InputLabel
                          id="dispatch_capacity"
                          htmlFor="dispatch_capacity"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          kW Capacity Committed for dispatch
                        </InputLabel>
                        <Input
                          labelid="dispatch_capacity"
                          id="dispatch_capacity"
                          name="dispatch_capacity"
                          classes={{ root: classes.rootsitedata }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.dispatch_capacity ? (
                                formik.errors.dispatch_capacity ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      Positive numbers allowed, shouldn't
                                      exceed 15.36 ( max 2 decimal digits )
                                    </Typography>
                                    <RedCross></RedCross>
                                  </Box>
                                ) : (
                                  <GreenTick></GreenTick>
                                )
                              ) : null}
                            </InputAdornment>
                          }
                          onChange={(event) => {
                            formik.setFieldValue(
                              'dispatch_capacity',
                              event.target.value,
                            )
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              ? e.target.value.split('.')[0] >= 10
                                ? e.target.value.slice(0, 5)
                                : e.target.value.slice(0, 4)
                              : e.target.value
                          }}
                          value={formik.values.dispatch_capacity}
                        ></Input>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        <InputLabel
                          id="dispatch_timings"
                          htmlFor="dispatch_timings"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          Dispatch Timings
                        </InputLabel>
                        <Select
                          labelid="dispatch_timings"
                          id="dispatch_timings"
                          name="dispatch_timings"
                          classes={{ root: classes.rootsitedata }}
                          onChange={(event) => {
                            formik.setFieldValue(
                              'dispatch_timings',
                              event.target.value,
                            )
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.dispatch_timings ? (
                                formik.errors.dispatch_timings ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      Required
                                    </Typography>
                                  </Box>
                                ) : null
                              ) : null}
                            </InputAdornment>
                          }
                          MenuProps={{
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                            classes: { paper: classes.menuPaper },
                          }}
                          value={formik.values.dispatch_timings}
                        >
                          {DISPATCH_TIMINGS_VALUES.map((option) => {
                            return (
                              <MenuItem key={option.key} value={option.value}>
                                {option.value}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        {' '}
                        <InputLabel
                          id="program"
                          htmlFor="program"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          Underlying Program
                        </InputLabel>
                        <Select
                          labelid="program"
                          id="program"
                          name="program"
                          classes={{ root: classes.rootsitedata }}
                          onChange={(event) => {
                            formik.setFieldValue(
                              'program',
                              event.target.value,
                            )
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.program ? (
                                formik.errors.program ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      Required
                                    </Typography>
                                  </Box>
                                ) : null
                              ) : null}
                            </InputAdornment>
                          }
                          MenuProps={{
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                          }}
                          value={formik.values.program}
                        >
                          {UNDERLYING_PROGRAM_VALUES.map((option) => {
                            return (
                              <MenuItem key={option.key} value={option.value}>
                                {option.value}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <Box>
                        {' '}
                        <FormControl
                          fullWidth
                          className={classes.formControlsitedata}
                        >
                          <InputLabel
                            id="rate"
                            htmlFor="rate"
                            classes={{ root: classes.inputlabelrootsitedata }}
                          >
                            $/kW bucket that was sanctioned
                          </InputLabel>
                          <Select
                            labelid="rate"
                            id="rate"
                            name="rate"
                            classes={{ root: classes.rootsitedata }}
                            onChange={(event) => {
                              formik.setFieldValue('rate', event.target.value)
                            }}
                            endAdornment={
                              <InputAdornment position="end">
                                {formik.values.rate ? (
                                  formik.errors.rate ? (
                                    <Box className={classes.errorLayout}>
                                      <Typography
                                        className={classes.errorMessage}
                                      >
                                        Required
                                      </Typography>
                                    </Box>
                                  ) : null
                                ) : null}
                              </InputAdornment>
                            }
                            MenuProps={{
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                              getContentAnchorEl: null,
                            }}
                            value={formik.values.rate}
                          >
                            {$perKW.map((option) => {
                              return (
                                <MenuItem key={option.key} value={option.value}>
                                  {option.value}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <FormControl
                        fullWidth
                        className={classes.formControlsitedata}
                      >
                        {' '}
                        <InputLabel
                          id="electric_account_number"
                          htmlFor="electric_account_number"
                          classes={{ root: classes.inputlabelrootsitedata }}
                        >
                          Electric Account Number
                        </InputLabel>
                        <Input
                          labelid="electric_account_number"
                          id="electric_account_number"
                          name="electric_account_number"
                          classes={{ root: classes.rootsitedata }}
                          endAdornment={
                            <InputAdornment position="end">
                              {formik.values.electric_account_number ? (
                                formik.errors.electric_account_number ? (
                                  <Box className={classes.errorLayout}>
                                    <Typography
                                      className={classes.errorMessage}
                                    >
                                      Numeric Characters Allowed, Min 6 and
                                      Max 12 digits
                                    </Typography>
                                    <RedCross></RedCross>
                                  </Box>
                                ) : (
                                  <GreenTick></GreenTick>
                                )
                              ) : null}
                            </InputAdornment>
                          }
                          onChange={(event) => {
                            formik.setFieldValue(
                              'electric_account_number',
                              event.target.value,
                            )
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              ? e.target.value.slice(0, 12)
                              : e.target.value
                          }}
                          value={formik.values.electric_account_number}
                        ></Input>
                      </FormControl>
                    </Box>
                  </Box>
                  <Box className={classes.formfieldssitedata}>
                    {' '}
                    <Box className={classes.formfieldvaluessitedata}>
                      <Box>
                        <FormControl
                          fullWidth
                          className={classes.formControlsitedata}
                        >
                          {' '}
                          <InputLabel
                            id="electric_meter_number"
                            htmlFor="electric_meter_number"
                            classes={{ root: classes.inputlabelrootsitedata }}
                          >
                            Electric Meter Number
                          </InputLabel>
                          <Input
                            labelid="electric_meter_number"
                            id="electric_meter_number"
                            name="electric_meter_number"
                            classes={{ root: classes.rootsitedata }}
                            endAdornment={
                              <InputAdornment position="end">
                                {formik.values.electric_meter_number ? (
                                  formik.errors.electric_meter_number ? (
                                    <Box className={classes.errorLayout}>
                                      <Typography
                                        className={classes.errorMessage}
                                      >
                                        Must be alphanumeric and 12 digits
                                      </Typography>
                                      <RedCross></RedCross>
                                    </Box>
                                  ) : (
                                    <GreenTick></GreenTick>
                                  )
                                ) : null}
                              </InputAdornment>
                            }
                            onChange={(event) => {
                              formik.setFieldValue(
                                'electric_meter_number',
                                event.target.value,
                              )
                            }}
                            onInput={(e) => {
                              e.target.value = e.target.value
                                ? e.target.value.slice(0, 12)
                                : e.target.value
                            }}
                            value={formik.values.electric_meter_number}
                          ></Input>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </div>
              <FormControl className={classes.layoutsitefiles}>
                <SectionHeader text="Files to be uploaded"></SectionHeader>
                <Box className={classes.fileuploadlayoutsitefiles}>
                  <FormControl>
                    <UploadFile
                      uploadfiledescription="Application Summary"
                      onValueChange={(file) => {
                        formik.setFieldValue('approval_form', file)
                      }}
                      existingfilename={site?.approval_form_key}
                      existingfileurl={site?.approval_form_presigned_url}
                    ></UploadFile>
                  </FormControl>
                  <FormControl>
                    <UploadFile
                      uploadfiledescription="Scanned copy of the Program T&C Document"
                      onValueChange={(file) => {
                        formik.setFieldValue('tandc_form', file)
                      }}
                      existingfilename={site?.tandc_form_key}
                      existingfileurl={site?.tandc_form_presigned_url}
                    ></UploadFile>
                  </FormControl>
                  <FormControl>
                    <UploadFile
                      uploadfiledescription="Scanned copy of the EDRP amendment (Optional)"
                      onValueChange={(file) => {
                        formik.setFieldValue('amendment_form', file)
                      }}
                      existingfilename={site?.amendment_form_key}
                      existingfileurl={site?.amendment_form_presigned_url}
                    ></UploadFile>
                  </FormControl>
                  <FormControl>
                    <UploadFile
                      uploadfiledescription="Scanned copy of the SDP agreement (Optional)"
                      onValueChange={(file) => {
                        formik.setFieldValue('agreement_form', file)
                      }}
                      existingfilename={site?.agreement_form_key}
                      existingfileurl={site?.agreement_form_presigned_url}
                    ></UploadFile>
                  </FormControl>
                </Box>
              </FormControl>
            </Box>
            <Divider classes={{ root: classes.dividerroot }}></Divider>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Box mt={1} mx={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="accept"
                        name="accept"
                        size="small"
                        checked={formik.values.accept}
                        onChange={() => {
                          formik.setFieldValue('accept', !formik.values.accept)
                        }}
                        color="primary"
                      />
                    }
                    label={
                      <div className={classes.checkboxLabel}>
                        I confirm the following :
                      </div>
                    }
                  />
                </Box>
                <Box>
                  <ul className={classes.lists}>
                    <li className={classes.formCheckboxLabel}>
                      I am authorized to submit the documents that I have
                      uploaded using this site, and have received permission
                      from the applicant to submit this information to Enphase
                      on the applicant’s behalf.
                    </li>
                    <li className={classes.formCheckboxLabel}>
                      I have read and understand{' '}
                      <a
                        href="https://enphase.com/privacy"
                        className={classes.links}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Enphase’s Privacy Policy{' '}
                      </a>{' '}
                      and{' '}
                      <a
                        href="https://enphase.com/terms"
                        className={classes.links}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of Service
                      </a>{' '}
                      (the “Policies”).{' '}
                    </li>
                    <li className={classes.formCheckboxLabel}>
                      The applicant has acknowledged that they have read and
                      understand the Policies.{' '}
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
            <Divider classes={{ root: classes.dividerroot }}></Divider>
            <Box className={classes.buttons}>
              {' '}
              <FilledButton
                label="Back"
                primary={false}
                width="160px"
                onClick={() => {
                  history.push('/installer')
                }}
              ></FilledButton>
              {site ? (
                <FilledButton
                  label="Submit"
                  primary={true}
                  disabled={
                    _.isEmpty(formik.errors)
                      ? formik.values.accept
                        ? false
                        : true
                      : true
                  }
                  width="160px"
                  onClick={() => {
                    reactOnSubmit(formik)
                  }}
                ></FilledButton>
              ) : (
                <FilledButton
                  label="Submit"
                  primary={true}
                  disabled={
                    _.isEmpty(formik.errors) && formik.dirty
                      ? formik.values.accept
                        ? false
                        : true
                      : true
                  }
                  width="160px"
                  onClick={() => {
                    reactOnSubmit(formik)
                  }}
                ></FilledButton>
              )}
            </Box>
          </Form>
        )}
      </Formik>
    </>
  )
}
export default SiteForm
